import React, { useEffect } from 'react';
import './styles.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser, faFloppyDisk, faXmark } from "@fortawesome/free-solid-svg-icons";
import FloatingActions, { FloatingAction } from '../FloatingActions';
import Card from '../Card';
import "./styles.css";
import UserSelectAdd, { UserOption } from '../UserSelectAdd';
import ItemDispositionMatrix, { DispositionColumn, IssuedItemRow } from '../ItemDispositionMatrix';
import useRouter from '@/store/useRouter';
import { useShallow } from "zustand/shallow";
import { RouterStoreItemKey } from '@/store/useRouter/types';
import useAppData from '@/store/useAppData';
import axios from "axios";
import { ItemRowValue } from '../ItemRow';
import { StockMovement } from '@/Utils/constants';

const NotReturnedCard: React.FC = () => {

    const selectedStock = useAppData(state => state.selectedStock);
    const loggedUser = useAppData(state => state.user);

    const router = useRouter(
        useShallow(state => ({
            go: state.go,
            history: state.history
        }))
    );


    const actions: FloatingAction[] = [
        {
            key: "2",
            label: "Zrušit",
            icon: <FontAwesomeIcon icon={faXmark} />,
            onClick: () => router.go({ key: RouterStoreItemKey.LISTITEMS })
        },
        {
            key: "1",
            label: "Uložit",
            icon: <FontAwesomeIcon icon={faFloppyDisk} />,
            onClick: () => onSave()
        }
    ]

    const columnsItemsDispositionMatrix: DispositionColumn[] = [
        // { key: "returnNew", title: "Vrátit na sklad\njako nové" },
        { key: "returnUsed", title: "Vrátit na sklad\njako použité" },
        // { key: "laundry", title: "Do čistírny" },
        { key: "dispose", title: "K likvidaci" },
        // { key: "notReturnedManko", title: "Nevráceno (manko)" },
        // { key: "notReturned", title: "Nevráceno" }
    ];

    const [selectedUsersState, setSelectedUsersState] = React.useState<UserOption[]>([]);
    const [selectedUserState, setSelectedUserState] = React.useState<string | null>(null);
    const [issuedItemsState, setIssuedItemsState] = React.useState<IssuedItemRow[]>([]);

    const SCAN_CHAR_MAX_INTERVAL = 40;
    const SCAN_SEQUENCE_TIMEOUT = 120;
    const SCAN_MIN_LENGTH = 1;

    type ScanType = "rfid" | "barcode" | "unknown";

    const scanBufferRef = React.useRef<string>("");
    const scanTimerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
    const lastKeyTimeRef = React.useRef<number>(0);
    const lastCharRef = React.useRef<string>("");
    const isScannerSequenceRef = React.useRef<boolean>(false);
    const scannerTargetRef = React.useRef<EventTarget | null>(null);
    const scannerInitialValueRef = React.useRef<string | null>(null);

    const classifyScan = (rawCode: string): ScanType => {
        const code = rawCode.trim();
        console.log("code10:");
        console.log(code);

        if (!code) return "unknown";

        if (/^\d{1,5}$/.test(code)) {
            const n = parseInt(code, 10);
            if (n >= 1 && n <= 50000) {
                return "barcode";
            }
        }

        if (/^[\p{L}0-9+]+$/u.test(code)) {
            return "rfid";
        }

        return "unknown";
    };

    const handleRfidScan = async (rfidCode: string) => {
        try {
            const userId = await loadUserByCardId(rfidCode);

            if (userId && userId?.length > 0) {
                setSelectedUserState(userId[0].id);
                const issuedItems = await loadIssuedItemsByUser(userId[0].id);
                setIssuedItemsState(issuedItems);
            }

        } catch (err) {
            console.error("Failed to handle RFID scan", err);
        }
    };

    useEffect(() => {
        loadUsers();
    }, []);

    useEffect(() => {
        setSelectedUserId("1");
    }, [selectedUsersState]);

    const setSelectedUserId = async (userId: string) => {
        setSelectedUserState(userId);

        const issuedItems = await loadIssuedItemsByUser(userId);
        setIssuedItemsState(issuedItems);
    };

    const loadIssuedItemsByUser = async (selectedUserId: string): Promise<IssuedItemRow[]> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/issuedItem/getByUser",
                data: {
                    stockId: selectedStock.id,
                    userId: selectedUserId,
                },
            });

            return res.data.issuedItems.map((issuedItem: any): IssuedItemRow => ({
                id: issuedItem.id,
                label: `${issuedItem.name}, ${issuedItem.state}, ${issuedItem.list1}, ${issuedItem.list2}, ${issuedItem.list3}`,
                qty: issuedItem.quantity,
                values: { returnNew: 0, returnUsed: 0, laundry: 0, dispose: 0, notReturned: 0, notReturnedManko: 0 }
            }));
        } catch (err) {
            console.error("Failed to load issued items", err);
            throw err;
        }
    };

    const loadUserByCardId = async (cardId: string): Promise<any> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/user/getByCardid",
                data: {
                    cardId: cardId
                },
            });

            return res.data.user;
        } catch (err) {
            console.error("Failed to load user by card id", err);
            throw err;
        }
    };

    const loadUsers = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/user/getAll",
                })
            );

            setSelectedUsersState(res.data.users);
        } catch (err) {
            throw err;
        }
    }

    const getIssuedItemByStockItemAndUserId = async (stockItemId: string, userId: string): Promise<any> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/issueditem/getByStockItemId",
                data: {
                    stockItemId: stockItemId,
                    objectId: userId
                },
            });

            return res.data.issuedItem;
        } catch (err) {
            console.error("Failed to load getIssuedItemByStockItemAndUserId", err);
            throw err;
        }
    };

    const insertIssuedItem = async (stockItemId: string, objectId: string, quantity: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/issueditem/insert",
                data: {
                    stockItemId: stockItemId,
                    objectId: objectId,
                    quantity: quantity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to insert issued item", err);
            throw err;
        }
    };

    const updateIssuedItemIncrement = async (issuedItemId: string, qauntity: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/issueditem/updateIncrement",
                data: {
                    id: issuedItemId,
                    quantity: qauntity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update issued item", err);
            throw err;
        }
    };

    const getStockItemByIssuedItem = async (issuedItemId: string): Promise<ItemRowValue> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/stockitem/getByIssuedItem",
                data: {
                    issueditemid: issuedItemId
                },
            });

            return res.data.stockItem[0];
        } catch (err) {
            console.error("Failed to load getByIssuedItem", err);
            throw err;
        }
    };

    const getStockItemByTypes = async (stockItem: ItemRowValue, stateId: string): Promise<ItemRowValue | null> => {
        try {
            const res = await axios({
                method: "post",
                url: "api/stockitem/getByTypes",
                data: {
                    stateId: stateId,
                    list1Id: stockItem.list1Id,
                    list2Id: stockItem.list2Id,
                    list3Id: stockItem.list3Id,
                    stockId: stockItem.stockId,
                    name: stockItem.name
                },
            });

            if (res.data.stockItem && res.data.stockItem.length > 0) {
                return res.data.stockItem[0];
            } else {
                return null;
            }

        } catch (err) {
            console.error("Failed to load getByTypes", err);
            throw err;
        }
    };

    const updateIssuedItemDecrement = async (issuedItemId: string, qauntity: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/issueditem/updateDecrement",
                data: {
                    id: issuedItemId,
                    quantity: qauntity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update issued item decrement", err);
            throw err;
        }
    };

    const removeIssuedItem = async (issuedItemId: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/issueditem/remove",
                data: {
                    id: issuedItemId
                },
            });

        } catch (err) {
            console.error("Failed to update issued item remove", err);
            throw err;
        }
    };

    const updateStockItemIncrement2 = async (stockItemId: string, qauntity: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/stockitem/updateIncrement2",
                data: {
                    id: stockItemId,
                    quantity: qauntity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update stock item increment2", err);
            throw err;
        }
    };

    const insertItem = async (item: ItemRowValue) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/stockitem/insert",
                data: {
                    name: item.name,
                    stateId: item.stateId,
                    list1Id: item.list1Id,
                    list2Id: item.list2Id,
                    list3Id: item.list3Id,
                    quantity: item.quantity,
                    stockId: item.stockId
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to insert stock item", err);
            throw err;
        }
    };

    const stockMovement = async (stockId: string, stockItemId: string, objectId: string, stockMovementId: string, quantity: number, userId: string, returnNew?: boolean, returnUsed?: boolean, dispose?: boolean, notReturned?: boolean, notReturnedManko?: boolean) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/log/stockMove",
                data: {
                    stockId: stockId,
                    stockItemId: stockItemId,
                    objectId: objectId,
                    quantity: quantity,
                    stockMovementId: stockMovementId,
                    returnNew: returnNew,
                    returnUsed: returnUsed,
                    dispose: dispose,
                    notReturned: notReturned,
                    notReturnedManko: notReturnedManko,
                    userId: userId
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to make stock movement item", err);
            throw err;
        }
    };

    const fixChipCode = (str) => {
        if (!str) {
            return str;
        }

        const charMap = {
            "é": "0",
            "+": "1",
            "ě": "2",
            "š": "3",
            "č": "4",
            "ř": "5",
            "ž": "6",
            "ý": "7",
            "á": "8",
            "í": "9"
        };

        return str.split("").map(char => charMap[char] || char).join("");
    }

    const onSave = async () => {
        if (selectedUserState) {

            let itemsProcessed = false;

            if (issuedItemsState && issuedItemsState.length > 0) {
                for (const issuedItem of issuedItemsState) {
                    let issuedItemQuantity = issuedItem.qty;

                    if (issuedItem.values.returnNew > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);
                        const stockItemBytState = await getStockItemByTypes(stockItemByIssuedItem, "17");
                        console.log("stockItemBytState");
                        console.log(stockItemBytState);

                        if (issuedItem.values.returnNew === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.returnNew;
                        } else if (issuedItem.values.returnNew < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.returnNew);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.returnNew;
                        }

                        if (stockItemBytState) {
                            await updateStockItemIncrement2(stockItemBytState.id, issuedItem.values.returnNew);
                        } else {
                            const newStockItem = { ...stockItemByIssuedItem, stateId: "17", quantity: issuedItem.values.returnNew };
                            const result = await insertItem(newStockItem);
                        }

                        itemsProcessed = true;
                    }

                    if (issuedItem.values.returnUsed > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);
                        const stockItemBytState = await getStockItemByTypes(stockItemByIssuedItem, "18");

                        console.log("stockItemByIssuedItem");
                        console.log(stockItemByIssuedItem);

                        console.log("stockItemBytState");
                        console.log(stockItemBytState);

                        if (issuedItem.values.returnUsed === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.returnUsed;
                        } else if (issuedItem.values.returnUsed < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.returnUsed);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.returnUsed;
                        }

                        if (stockItemBytState) {
                            await updateStockItemIncrement2(stockItemBytState.id, issuedItem.values.returnUsed);

                            await stockMovement(selectedStock.id, stockItemBytState.id, selectedUserState, String(StockMovement.Return), issuedItem.values.returnUsed, loggedUser.id, null, true, null, null, null);
                        } else {
                            const newStockItem = { ...stockItemByIssuedItem, stateId: "18", quantity: issuedItem.values.returnUsed };
                            const result = await insertItem(newStockItem);

                            await stockMovement(selectedStock.id, result, selectedUserState, String(StockMovement.Return), issuedItem.values.returnUsed, loggedUser.id, null, true, null, null, null);
                        }

                        itemsProcessed = true;
                    }


                    if (issuedItem.values.dispose > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);

                        if (issuedItem.values.dispose === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.dispose;
                        } else if (issuedItem.values.dispose < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.dispose);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.dispose;
                        }

                        await stockMovement(selectedStock.id, stockItemByIssuedItem.id, selectedUserState, String(StockMovement.Return), issuedItem.values.dispose, loggedUser.id, null, null, true, null, null);

                        itemsProcessed = true;
                    }

                    if (issuedItem.values.laundry > 0) {
                        const laundryObjectId = "1";
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);

                        if (issuedItem.values.laundry === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.laundry;
                        } else if (issuedItem.values.laundry < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.laundry);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.laundry;
                        }

                        const issuedItemFroLaundry = await getIssuedItemByStockItemAndUserId(stockItemByIssuedItem.id, laundryObjectId);
                        if (issuedItemFroLaundry && issuedItemFroLaundry.length > 0) {
                            await updateIssuedItemIncrement(issuedItemFroLaundry[0].id, issuedItem.values.laundry);
                        } else {
                            await insertIssuedItem(stockItemByIssuedItem.id, laundryObjectId, issuedItem.values.laundry);
                        }

                        itemsProcessed = true;
                    }

                    if (issuedItem.values.notReturned > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);

                        if (issuedItem.values.notReturned === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.notReturned;
                        } else if (issuedItem.values.notReturned < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.notReturned);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.notReturned;
                        }

                        itemsProcessed = true;
                    }

                    if (issuedItem.values.notReturnedManko > 0) {
                        const stockItemByIssuedItem = await getStockItemByIssuedItem(issuedItem.id);

                        if (issuedItem.values.notReturnedManko === /*issuedItem.qty*/ issuedItemQuantity) {
                            await removeIssuedItem(issuedItem.id);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.notReturnedManko;
                        } else if (issuedItem.values.notReturnedManko < /*issuedItem.qty*/ issuedItemQuantity) {
                            await updateIssuedItemDecrement(issuedItem.id, issuedItem.values.notReturnedManko);
                            issuedItemQuantity = issuedItemQuantity - issuedItem.values.notReturnedManko;
                        }

                        itemsProcessed = true;
                    }
                }
            }

            if (itemsProcessed) {
                router.go({ key: RouterStoreItemKey.LISTITEMS })
            }
        }
    };

    return (
        <Card title="Příjem z čistírny">
            <div className="item-list-stack">

                <div>
                    <UserSelectAdd
                        header=""
                        users={selectedUsersState}
                        valueId={selectedUserState}
                        onChange={setSelectedUserId}
                        readOnly={true}
                        hideHint={true}
                    />
                </div>

                <ItemDispositionMatrix
                    titleLeft={"Položky"}
                    columns={columnsItemsDispositionMatrix}
                    rows={issuedItemsState}
                    onChange={setIssuedItemsState}
                />
            </div>

            {actions?.length ? (
                <div className="item-list-actions">
                    <FloatingActions actions={actions} />
                </div>
            ) : null}
        </Card>
    );
};

export default NotReturnedCard;